import React, {useState} from 'react';
import { withRouter } from 'react-router-dom';
import { WORDPRESS_HOST } from '../../../config';
import axios from 'axios';
import moment from 'moment';
import Loader from 'react-fullpage-custom-loader';
import './Article.scss';

function decodeEntities(str) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(str, 'text/html');
  return doc.documentElement.textContent;
}

const Article = ({match}) => {
  const {id} = match.params;
  const [post, setPost] = useState({});
  const [called, setCalled] = useState(false);
  if (!called) {
    axios
      .get(`${WORDPRESS_HOST}/wp-json/wp/v2/posts/${id}?_fields=title,date,id,featured_media,content`)
      .then(async ({ data }) => {
        const { id, title, date, featured_media, content } = data;
        let image = "";
        if (featured_media) {
          try {
            const mediaRes = await axios.get(`${WORDPRESS_HOST}/wp-json/wp/v2/media/${featured_media}?_fields=source_url`);
            image = mediaRes.data.source_url;
          } catch (e) {}
        }
        setPost({
          id,
          title: title.rendered,
          date: moment(date).format("DD.MM"),
          image,
          content: content.rendered
        });
        setCalled(true);
      })
      .catch((e) => {
        console.log(e)
        setCalled(true);
      });
    }

    if(!called)
    return <Loader color="#56bad9" fadeIn={true} wrapperBackgroundColor="#000" sentences={[]} loaderType="ball-grid-pulse" />
    
    return <div className="News__screen">
          <div className="News__wrapper">
            <div className="News_photo">
              <img
                className="Photos"
                src={post.image}
                alt=""
              />
            </div>
               <div className="News_title">
                 <div className="Left_title">{post.title ? decodeEntities(post.title) : ''}</div>
                 <div className="Right_title">{post.date}</div> 
                </div>
            <div className="News_text" dangerouslySetInnerHTML={{__html: post.content}} />
          </div>
        </div>
}


export default withRouter(Article);